import { Roles } from './blocks';

const AccountRolesContent = () => {
  return <Roles />;
};

export { AccountRolesContent };
